module.exports = __webpack_public_path__ + "static/media/ls.fd0cc2e1.svg";